
import { FILTER_LABELS } from '@/types/filter-options';

// Função para normalizar altura do banco para exibição
export const normalizeHeightDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  // Mapear valores do banco para labels de exibição
  const bankToDisplayMapping: Record<string, string> = {
    '170–174 cm': FILTER_LABELS.height["171_175"],
    '165–169 cm': FILTER_LABELS.height["166_170"],
    '175–179 cm': FILTER_LABELS.height["176_180"],
    '160–164 cm': FILTER_LABELS.height["161_165"],
    '180–184 cm': FILTER_LABELS.height["181_185"],
    '155–159 cm': FILTER_LABELS.height["156_160"],
    '150–154 cm': FILTER_LABELS.height["150_155"],
    '185–189 cm': FILTER_LABELS.height["186_190"],
    'Abaixo de 150 cm': FILTER_LABELS.height["abaixo_150"],
    'Acima de 190 cm': FILTER_LABELS.height["acima_200"]
  };
  
  // Primeiro tentar mapeamento direto do banco
  if (bankToDisplayMapping[value]) {
    return bankToDisplayMapping[value];
  }
  
  // Tentar mapeamento pelos labels existentes
  const heightLabels = FILTER_LABELS.height;
  for (const [key, label] of Object.entries(heightLabels)) {
    if (value === key) {
      return label;
    }
  }
  
  return value; // Retornar valor original se não encontrar mapeamento
};

// Função para normalizar tipo de corpo
export const normalizeBodyTypeDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const bodyTypeLabels = FILTER_LABELS.bodyType;
  for (const [key, label] of Object.entries(bodyTypeLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};

// Função para normalizar cor do cabelo
export const normalizeHairColorDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const hairColorLabels = FILTER_LABELS.hairColor;
  for (const [key, label] of Object.entries(hairColorLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};

// Função para normalizar cor dos olhos
export const normalizeEyeColorDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const eyeColorLabels = FILTER_LABELS.eyeColor;
  for (const [key, label] of Object.entries(eyeColorLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};

// Função para normalizar fumante
export const normalizeSmokerDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const smokerLabels = FILTER_LABELS.smoker;
  for (const [key, label] of Object.entries(smokerLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};

// Função para normalizar bebidas
export const normalizeDrinkerDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const drinkerLabels = FILTER_LABELS.drinker;
  for (const [key, label] of Object.entries(drinkerLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};

// Função para normalizar estado civil
export const normalizeMaritalStatusDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const maritalStatusLabels = FILTER_LABELS.maritalStatus;
  for (const [key, label] of Object.entries(maritalStatusLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};

// Função para normalizar tipo de relacionamento
export const normalizeRelationshipTypeDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const relationshipTypeLabels = FILTER_LABELS.relationshipType;
  for (const [key, label] of Object.entries(relationshipTypeLabels)) {
    if (value === key || value === label) {
      return label as string;
    }
  }
  
  return value;
};

// Função para normalizar disponibilidade para viajar
export const normalizeTravelAvailabilityDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const travelAvailabilityLabels = FILTER_LABELS.travelAvailability;
  for (const [key, label] of Object.entries(travelAvailabilityLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};

// Função para normalizar sigilo presença
export const normalizeSigiloPresencaDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const sigiloPresencaLabels = FILTER_LABELS.sigilo_presenca;
  for (const [key, label] of Object.entries(sigiloPresencaLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};

// Função para normalizar tatuagens e piercings (que usam o formato original)
export const normalizeTattoosDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const tattoosLabels = FILTER_LABELS.tattoos;
  for (const [key, label] of Object.entries(tattoosLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};

export const normalizePiercingsDisplay = (value: string): string => {
  if (!value) return 'Não informado';
  
  const piercingsLabels = FILTER_LABELS.piercings;
  for (const [key, label] of Object.entries(piercingsLabels)) {
    if (value === key || value === label) {
      return label;
    }
  }
  
  return value;
};
